import ClientBasicInfo from './ClientBasicInfo';
import FinancialInfo from './FinancialInfo';
import CurrentInsurance from './CurrentInsurance';
import AdditionalClientInfo from './AdditionalClientInfo';
import MonthlyExpenses from './MonthlyExpenses';
import Quoter from './Quoter';
import Advisor from './Advisor';

export { 
    ClientBasicInfo, 
    FinancialInfo, 
    CurrentInsurance, 
    AdditionalClientInfo, 
    MonthlyExpenses,
    Quoter, 
    Advisor
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/index.js